import { PaletteColor } from '@utils/types';

import {
  SegmentOutline,
  CheckMark,
  Container,
  Outline,
  SegmentCheck,
  Unchecked,
} from './CheckboxOutlineStyle';

type CheckIconProps = {
  checked: boolean;
  onClick?(): void;
  outlineColor?: PaletteColor;
  checkMarkColor?: PaletteColor;
  segment?: boolean;
};

const CheckIcon = ({
  checked,
  onClick,
  checkMarkColor,
  outlineColor,
  segment,
}: CheckIconProps) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    onClick?.();
  };
  return checked ? (
    <>
      {segment ? (
        <Container
          onClick={handleClick}
          checkMarkColor={checkMarkColor}
          outlineColor={outlineColor}
          clickable={!!onClick}
        >
          <SegmentOutline />
          <SegmentCheck />
        </Container>
      ) : (
        <Container
          onClick={handleClick}
          checkMarkColor={checkMarkColor}
          outlineColor={outlineColor}
          clickable={!!onClick}
        >
          <Outline />
          <CheckMark />
        </Container>
      )}
    </>
  ) : (
    <Unchecked
      segment={segment}
      onClick={handleClick}
      outlineColor={outlineColor}
    />
  );
};

export default CheckIcon;
